import type { FlipperState } from './Flipper.types';

export const INIT_STATE: FlipperState = {
  featuresSaved: {},
  features: {},
};
